export default {
  mounted() {
    this.el.addEventListener('dragstart', (event) => {
      event.target.classList.add('dragging')
    })
    this.el.addEventListener('dragend', (event) => {
      event.target.classList.remove('dragging')
    })
  }
}
